/**
 * Blueprint Border Component
 *
 * Adds interactive functionality to blueprint border elements.
 */

import { gsap } from '../gsap/init';

/**
 * Initialize blueprint border interactions
 */
export function initBlueprintBorders(): void {
  const blueprintBorders = document.querySelectorAll('.blueprint-border');

  blueprintBorders.forEach(border => {
    // Add hover effect with GSAP if available
    if (typeof gsap !== 'undefined') {
      border.addEventListener('mouseenter', () => {
        gsap.to(border, {
          scale: 1.05,
          duration: 0.3,
          ease: 'power2.out',
        });
      });

      border.addEventListener('mouseleave', () => {
        gsap.to(border, {
          scale: 1,
          duration: 0.3,
          ease: 'power2.out',
        });
      });
    }
  });
}
